import React, { createContext, useContext, useState } from 'react';

const RootContext = createContext(null);
export const RootProvider = ({children}) => {
  const [showProjectWin, setShowProjectWin] = useState(false);
  const [showUploadWin, setShowUploadWin] = useState(false);

  const [videoList, setVideoList] = useState([]);

  return <RootContext.Provider value={{
    showProjectWin,
    showUploadWin,
    videoList,

    setShowProjectWin,
    setShowUploadWin,
    setVideoList,
  }}>
    {children}
  </RootContext.Provider>;
};

export const useRoot = () => {
  return useContext(RootContext) || {
    showProjectWin: false,
    showUploadWin: false,
    videoList: [],

    setShowProjectWin: () => {},
    setShowUploadWin: () => {},
    setVideoList: () => {},
  };
};